import React, { useState } from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import ComplianceTab from './compliance/ComplianceTab';
import VatTab from './vat/VatTab';
import IntraCompanyTab from './intraCompany/IntraCompanyTab';
import { useTranslatedMessages } from '../../../hooks/useTranslatedMessages';
import { MIS_TABS, MIS_UI } from '../utils/misConstants';
import { useGetMisComplianceHandler } from '../dataHandlers/getMisComplianceHandler';
import { useGetMisVatHandler } from '../dataHandlers/getMisVatHandler';

const MisDashboardTabs = ({ queryParams }) => {
  const { misDashboard: m } = useTranslatedMessages();
  const [value, setValue] = useState(MIS_TABS.COMPLIANCE);
  const { complianceData, isLoading: complianceLoading } = useGetMisComplianceHandler({
    queryParams,
    enabled: value === MIS_TABS.COMPLIANCE,
  });
  const { vatData, isLoading: vatLoading } = useGetMisVatHandler({
    queryParams,
    enabled: value === MIS_TABS.VAT,
  });

  const tabs = [
    {
      value: MIS_TABS.COMPLIANCE,
      label: m.tabs?.compliance ?? 'Compliance',
      content: <ComplianceTab complianceData={complianceData} loading={complianceLoading} />,
    },
    {
      value: MIS_TABS.VAT,
      label: m.tabs?.vat ?? 'VAT',
      content: <VatTab vatData={vatData} loading={vatLoading} />,
    },
    {
      value: MIS_TABS.INTRA_COMPANY,
      label: m.tabs?.intra_company ?? 'Intra-company',
      content: <IntraCompanyTab />,
    },
  ];

  return (
    <Box sx={{ mt: 0.5 }}>
      <Tabs
        value={value}
        onChange={(_, next) => setValue(next)}
        textColor="inherit"
        indicatorColor="secondary"
        variant="fullWidth"
        sx={{
          mb: 2,
          maxWidth: 540,
          bgcolor: MIS_UI.SURFACE_MUTED,
          borderRadius: 1.5,
          minHeight: 40,
          p: 0.5,
          '& .MuiTabs-indicator': {
            display: 'none',
          },
          '& .MuiTab-root': {
            minHeight: 32,
            textTransform: 'none',
            fontWeight: 500,
            fontSize: 13,
            borderRadius: 1,
            color: MIS_UI.TAB_TEXT,
          },
          '& .Mui-selected': {
            bgcolor: MIS_UI.SURFACE_WHITE,
            color: MIS_UI.TAB_TEXT_SELECTED,
            boxShadow: '0 1px 2px rgba(0, 0, 0, 0.06)',
          },
        }}
      >
        {tabs.map((tab) => (
          <Tab key={tab.value} value={tab.value} label={tab.label} />
        ))}
      </Tabs>

      {tabs.map((tab) =>
        tab.value === value ? (
          <Box key={tab.value} sx={{ mt: 1 }}>
            {tab.content}
          </Box>
        ) : null,
      )}
    </Box>
  );
};

export default MisDashboardTabs;
